<template>
  <div id="app" v-bind:class="light_theme ? 'light-theme' : 'dark-theme'">

    <div class="container">
      <router-view />    
    </div>
    
  </div>
</template>

<script>
import {bus} from './main'

export default {
  components: {
  
  },
  data() {
    return {
      light_theme: false,
      menu_opened: false
    }
  },
  methods: {
    menu_toggled() {this.menu_opened = !this.menu_opened}
  },
  mounted() {
    bus.$on('light_theme', () => {this.light_theme = !this.light_theme})
  }
}
</script>

<style>
  /* :root {
    --main-background: #e8e7e9;
    --menu-background: #d4d4d4;
    --element-background: #d2dadd;
    --primary: #31d2b3;
    --accent: #7c8083;
    --action: #2883d6;
    --light: #54595e;
    --error: #c53d3b;
    --success: #35c4a4;
    --font: #54595e;

    --main-background: #323538;
    --menu-background: #2a2c2e;
    --element-background: #54595e;
    --primary: #31d2b3;
    --accent: #acafb3;
    --action: #2883d6;
    --light: #ebecef;
    --error: #c53d3b;
    --success: #35c4a4;
    --font: #ebecef; 
  } */

  .light-theme {
    --main-background: #ffffff;
    --menu-background: rgb(236, 236, 238);
    --element-background: #e4e3e1;
    --primary: #7ca934;
    --accent: #8a8a8a;
    --action: #2883d6;
    --light: #54595e;
    --error: #c53d3b;
    --success: #35c4a4;
    --font: #383838;
  }
  .dark-theme {
    --main-background: #323538;
    --menu-background: #2a2c2e;
    --element-background: #54595e;
    --primary: #31d2b3;
    --accent: #acafb3;
    --action: #2883d6;
    --light: #ebecef;
    --error: #c53d3b;
    --success: #35c4a4;
    --font: #ebecef; 
  }

  *, *::after, *::before {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  *::selection {
    background-color: var(--primary);
  }
  html {
    height: 100%;
  }
  @font-face {
    font-family: 'Segoe UI Regular';
    font-style: normal;
    font-weight: normal;
    src: local('../src/assets/fonts/Segoe UI.woff'), url('../src/assets/fonts/Segoe UI.woff') format('woff');
  }
  body {
    /* font-family: 'Ubuntu', sans-serif; */
    font-family: 'Oswald', sans-serif;
    font-family: 'Segoe UI Regular';
    font-size: 16px;
    font-weight: 500;
    height: 100%;
    min-height: 100vh;
    background-color: var(--main-background);
    color: var(--font);
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: var(--font);
    background-color: var(--main-background);
    text-align: center;
    min-height: 100vh;
  }
  .app-wrapper {
    transition: 290ms ease-in-out;
  }
  .closed { padding-left: 220px }

  /* INPUT-GROUPS */
  .icon {
    font-size: 23px;
    color: var(--accent);
    transition: 250ms ease-in-out;
  }
  .input-group {
    /* border: 1px dashed white; */
    position: relative;
    margin-top: 10px;
  }
  .input-group .icon {
    position: absolute;
    left: 20px;
    top: 20px;
  }

  .input-group input:focus ~ .icon {
    color: var(--primary);
  }
  
  /* WITH LABEL */
  .input-group.label label {
    display: block;
    text-align: left;
    padding-left: 10px;
  }
  .input-group.label .icon {
    top: 36px;
  }

  /* WITH HINT*/
  .input-hint {
    font-weight: 300;
    font-size: 14px;
    display: block;
    color: var(--primary);
  }

  /* WITH NO ICON */
  .input-group.no-icon input, .no-icon {
    padding: 15px 25px;
  }


  /* RADIO buttons */
  .radio-wrapper {
    padding: 0;
  }
  .radio-container {
    /* border: 1px dashed white; */
    height: 52px;
    position: relative;
    display: flex;
    align-items: stretch;
  }
  .radio-container input[type="radio"] {
    height: 20px;
    width: 20px;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .radio-container span {
    border: 2px solid var(--element-background);
    background-color: var(--element-background);
    color: var(--accent);
    border-radius: 50px;
    display: inline-block;
    min-width: 100%;
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    padding-left: 35px;
    padding-right: 10px;
    text-decoration: line-through;
    transition: 250ms ease-in-out;
    cursor: pointer;
    overflow: hidden;
  }

  .radio-container input[type="radio"]:focus + span {
    border-color: var(--primary);
  }
  .radio-container input[type="radio"]:checked + span {
    text-decoration: none;
    color: var(--font);
  }

  .currency {
    width: 150px;
    margin-left: 20px;
    padding: 14px 25px;
  }
  .toggle-wrapper {
    margin: 5px 0 35px 5px;
    border-bottom: 2px solid var(--element-background);
    border-left: 2px solid var(--element-background);
    border-bottom-left-radius: 30px;
    border-top-left-radius: 20px;
    padding: 10px 0 20px 25px;
  }


  .row {
    /* border: 1px dashed red; */
    display: grid;
    grid-column-gap: 20px;
    grid-template-columns: 1fr 1fr;
  }
  .row > div {
    /* border: 1px dashed white; */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .row > div > label {
    padding: 0!important;
    width: 30%;
  }
  .row div:first-child {
    text-align: left;
  }
  .row.icons {
    position: relative;
  }
  .row.icons span {
    font-size: 18px;
    position: absolute;
    right: 54%;
    top: 50%;
    transform: translateY(-50%);
  }


  input,
  select,
  button,
  textarea {
    font-family: 'Ubuntu', sans-serif;
    font-family: 'Segoe UI Regular';
    display: block;
    width: 100%;
    padding: 15px 25px 15px 55px;
    font-size: 16px;
    border: none;
    border: 2px solid var(--main-background);
    border-radius: 50px;
    background-color: var(--element-background);
    color: var(--font);
    transition: 150ms ease-in-out;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type=number] {
    -moz-appearance:textfield;
  }
  input::placeholder {
    color: var(--accent);
    font-weight: 300;
  }
  input:focus,
  select:focus, 
  button:focus,
  textarea:focus {
    outline: none;
    border-color: var(--primary);
  }
  input:focus ~ label {
    color: var(--primary);
  }


  input[type="date"] {
    padding: 13px 25px 13px 55px;
    color: var(--font);
    
  }
  select {
    padding: 15px 25px;
    /* -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../public/images/web/dropdown.png') right / 25px no-repeat var(--element-background);
    background-position: calc(100% - 10px) center !important;  */
  }
  option {
    font-size: 18px;
  }
  button,
  input[type='submit'] {
    color: var(--primary);
    background-color: var(--element-background);
    padding: 15px 25px;
    text-transform: uppercase;
    font-weight: 700;
    margin-top: 15px;
    cursor: pointer;
  }
  button:hover,
  input[type='submit']:hover {
    background-color: var(--primary);
    color: var(--element-background);
  }
  textarea {
    border-radius: 25px;
    padding: 15px 25px;
    margin-top: 15px;
  }
  textarea::placeholder {
    color: var(--accent);
    font-weight: 300;
  }

  .container {
    /* border: 1px dashed white; */
    width: 90%;
    margin: 0 auto;
  }

  .title {
    text-transform: uppercase;
    font-size: 30px;
    font-weight: 700;
    margin: 10px auto 20px;
  }
  .subtitle {
    text-transform: uppercase;
    font-size: 23px;
    font-weight: 700;
    margin: 15px auto 25px;
  }


  

  .error {color: var(--error)!important}
  .error .icon {color: var(--error)!important}
  .error > input {border-color: var(--error)!important}

  .success {color: var(--success)!important}
  .success .icon {color: var(--success)!important}
  .success > input {border-color: var(--success)!important}





 




  @media only screen and (max-width: 768px) {
    .container {
      width: 100%;
      padding: 0 5px;
    }
    .title {margin: 10px auto 10px}
    .row {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
    }
    /* .row > div {
      justify-content: space-between;
      display: flex;
    } */
    .row > div > label {
      margin: 5px 0;
      padding: 0!important;
    }
    .radio-wrapper {
      padding: 0 2px;
    }
    .radio-label {
      padding: 0;
      margin: 0;
      min-width: 30%;
    }
    .radio-label input[type='radio'] {
      padding: 0;
      margin: 0 5px;
    }
    .radio-label span {
      padding: 0;
      margin: 0;
    }
    .row.icons span {right: 5%}
    .toggle-wrapper {
      margin-bottom: 20px;
      padding: 10px;
      margin-left: 0px;
    }
  }
</style>
